import { PromptFunction } from '../../types';
import novelsFunctions from './novels';
import chaptersFunctions from './chapters';
import codexFunctions from './codex';
import scenesFunctions from './scenes';
import contextFunctions from './context';
import pointOfViewFunctions from './pointOfView';
import logicFunctions from './logic';
import textFunctions from './text';
import compositionFunctions from './composition';
import listsFunctions from './lists';
import otherFunctions from './other';


/**
 * 自定义函数
 * @returns 自定义函数对象
 */
export const customFunctions: Record<string, PromptFunction> = {
  ...novelsFunctions,
  ...chaptersFunctions,
  ...codexFunctions,
  ...scenesFunctions,
  ...contextFunctions,
  ...pointOfViewFunctions,
  ...logicFunctions,
  ...textFunctions,
  ...compositionFunctions,
  ...listsFunctions,
  ...otherFunctions,
}; 